import { useContext } from 'react'
import { ModalContext } from '../components/container'

export const useModal = () => {
  const { pushModal, deleteModal } = useContext(ModalContext)
  return { pushModal, deleteModal }
}
